import { render, staticRenderFns } from "./ConfigRoleFilter.vue?vue&type=template&id=9d9dffe8"
import script from "./ConfigRoleFilter.vue?vue&type=script&lang=js"
export * from "./ConfigRoleFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports